module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Adventures with Canine Cupids Box Set")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By Deirdre O’Dare")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004#a29"
    }
  }, [_vm._v("Doggone Love")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/005#a30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Maltese Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/005#a31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/006#a32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/007#a33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Leash on Life")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Is Snowblind")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/019#a47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/020#a48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/021#a49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/022#a50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/023#a51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/024#a52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d45bd66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0